(function () {
  'use strict';

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function initFacebookProofSlider() {
    $all('[data-ds-fb-slider]').forEach(function (wrap) {
      var track = $('[data-ds-fb-track]', wrap);
      var cards = $all('.ds-fb-proof__card', track);
      var prev = $('[data-ds-fb-prev]', wrap);
      var next = $('[data-ds-fb-next]', wrap);
      var dotsWrap = $('[data-ds-fb-dots]', wrap);
      if (!track || cards.length === 0) return;

      var idx = 0;
      var mq = window.matchMedia('(min-width: 900px)');

      function isDesktop() {
        return mq.matches;
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        cards.forEach(function (_, n) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ds-fb-proof__dot' + (n === idx ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to post ' + (n + 1));
          dot.addEventListener('click', function () {
            idx = n;
            render();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function render() {
        if (isDesktop()) {
          track.style.transform = '';
          return;
        }
        var card = cards[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        var step = card.getBoundingClientRect().width + gap;
        track.style.transform = 'translateX(-' + idx * step + 'px)';
        if (dotsWrap) {
          $all('.ds-fb-proof__dot', dotsWrap).forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === idx);
          });
        }
        if (prev) prev.disabled = cards.length <= 1;
        if (next) next.disabled = cards.length <= 1;
      }

      function go(delta) {
        if (isDesktop()) return;
        idx += delta;
        if (idx >= cards.length) idx = 0;
        if (idx < 0) idx = cards.length - 1;
        render();
      }

      buildDots();
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      mq.addEventListener('change', function () {
        idx = 0;
        buildDots();
        render();
      });
      window.addEventListener('resize', render);
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacebookProofSlider);
  } else {
    initFacebookProofSlider();
  }

  document.addEventListener('shopify:section:load', initFacebookProofSlider);
})();
